import React from "react";
import "./ProductsPage.styles.scss";
import Products from "../../components/Products/Products";

const ProductsPage = () => {
  return <Products />;
};

export default ProductsPage;
